import axios from "../libs/api.request.js";

// 加入购物车
export const submitCart = params => {
  return axios.request({
    url: "pc/order/saveOrder",
    method: "post",
    data: params
  });
};

// 直接提交到订单列表
export const submitOrder = params => {
  return axios.request({
    url: "pc/order/saveSubmitOrder",
    method: "post",
    data: params
  });
};
// 编辑订单
export const editOrder = params => {
  return axios.request({
    url: "pc/order/getOrderInfo",
    method: "get",
    params
  });
};
// 购物车列表
export const getOrderCartList = params => {
  return axios.request({
    url: "pc/order/getOrderCartList",
    method: "get",
    params: params
  });
};
// 品类列表
export const getClothDictList = params => {
  return axios.request({
    url: "admin/dict/getClothDictList",
    method: "get",
    params: params
  });
};
// 订单号列表
export const getOrderCodeList = params => {
  return axios.request({
    url: "pc/order/getOrderCodeList",
    method: "get",
    params: params
  });
};
// 获取购物车搜索项字典
export const getOrderSearch = params => {
  return axios.request({
    url: "pc/dictsystem/getOrderSearch",
    method: "get",
    params: params
  });
};
// 修改购物车订单数量
export const updateCartOrderAmount = params => {
  return axios.request({
    url: "pc/order/updateCartOrderAmount",
    method: "get",
    params: params
  });
};
// 订单客户信息
export const getOrderCustomerById = params => {
  return axios.request({
    url: "pc/ordercustomer/getOrderCustomerById",
    method: "get",
    params: params
  });
};
// 编辑客户
export const updateOrderCustomerById = data => {
  return axios.request({
    url: "/pc/ordercustomer/updateOrderCustomerById",
    method: "post",
    data: data
  });
};
// 追加西裤
export const updateOrderAddproduct = params => {
  return axios.request({
    url: "/pc/order/updateOrderAddproduct",
    method: "get",
    params: params
  });
};
// 订单详情
export const getCartOrderDetail = data => {
  return axios.request({
    url: "/pc/order/getCartOrderDetail",
    method: "get",
    params: data
  });
};
// 删除订单
export const updateOrder = data => {
  return axios.request({
    url: "/pc/order/updateOrder",
    method: "get",
    params: data
  });
};
// 计算订单价格
export const getOrderSumPrice = data => {
  return axios.request({
    url: "/pc/order/getOrderSumPrice",
    method: "get",
    params: data
  });
};
// 提交订单
export const pushOrder = data => {
  return axios.request({
    url: "/pc/order/pushOrder",
    method: "get",
    params: data
  });
};
// 标签列表
export const getLabelList = data => {
  return axios.request({
    url: "/pc/label/getLabelList",
    method: "get",
    params: data
  });
};
// 保存标签
export const saveOrderLabel = data => {
  return axios.request({
    url: "/pc/label/saveLabel",
    method: "post",
    data: data
  });
};
//关联订单标签
export const saveOrderLabels = data => {
  return axios.request({
    url: "/pc/label/editOrderLabel",
    method: "get",
    params: data
  });
};
//删除标签
export const deleteLabel = labelId => {
  return axios.request({
    url: "/pc/label/del/" + labelId,
    method: "POST"
  });
};
//撤单
export const canceMtmOrder = data => {
  return axios.request({
    url: "/pc/order/canceMtmOrder",
    method: "get",
    params: data
  });
};
//购物车推荐
export const getRecommendClothList = data => {
  return axios.request({
    url: "/pc/order/getRecommendClothList",
    method: "get",
    params: data
  });
};
//购物车提交单耗
export const pushOrderCost = data => {
  return axios.request({
    url: "/pc/order/pushOrderCost",
    method: "post",
    data: data
  });
};
//订单的计价公式
export const getOrderFormula = data => {
  return axios.request({
    url: `/pc/order/getOrderFormula/${data}`,
    method: "get"
  });
};
//单耗详情
export const getOrderCostDetail = data => {
  return axios.request({
    url: "/pc/order/getOrderCostDetail",
    method: "get",
    params: data
  });
};

export const preCommit = data => {
  return axios.request({
    url: `/pc/order/preCommit/${data}`,
    method: "post"
  });
}
export const selectDictBasicTree = data => {
  return axios.request({
    url: `/pc/dictbasic/selectDictBasicTree?category=${data.id}`,
    method: "get",
    params: data
  });
}
// 分类列表
export const categoryList = data => {
  return axios.request({
    url: `/pc/goods/category`,
    method: "get",
    params: data
  });
}
// 分类列表2
export const categoryListStyle = data => {
  return axios.request({
    url: `/pc/style/category`,
    method: "get",
    params: data
  });
}
// 列表
export const goodsList = data => {
  return axios.request({
    url: `/pc/goods/list`,
    // url: `/pc/goods/category`,
    method: "get",
    params: data
  });
}
// 列表2
export const goodsListStyle = data => {
  return axios.request({
    url: `/pc/style/list`,
    method: "get",
    params: data
  });
}
// 详情
export const goodsDetail = data => {
  return axios.request({
    url: `/pc/goods/detail/${data.id}`,
    method: "get"
  });
}
// 详情2
export const goodsDetailStyle = data => {
  return axios.request({
    url: `/pc/style/detail/${data.id}`,
    method: "get"
  });
}
// 提交
export const submit = data => {
  return axios.request({
    url: `/pc/goods/buy`,
    method: "post",
    data
  });
}
// 提交
export const submitStyle = data => {
  return axios.request({
    url: `/pc/style/buy`,
    method: "post",
    data
  });
}

// 加入购物车
export const saveToCart = data => {
  return axios.request({
    url: `/pc/goods/saveToCart`,
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/cart.js